import React from 'react';

import { useForm } from 'react-hook-form';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';

import { LbInput } from '@infoods/lifebase-ui';

import { GridTableRow } from '../../../../shared/components/table-components';
import { scanIqCustomerListStore } from '../../../stores/scanIqCustomersListStore';
import { ScanIqCustomerListFilterFormValues } from '../../../interfaces/ScanIqCustomerListFilters';
import { useAutoSubmitForm } from '../../../../shared/hooks/useAutoSubmitForm';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';

const FilterRow = observer(() => {
  const { filterMethods } = scanIqCustomerListStore;
  const { isSuperAdmin } = loggedInUserDataStore;

  const { applyFilters } = filterMethods;

  const { control, reset, watch, handleSubmit } =
    useForm<ScanIqCustomerListFilterFormValues>();

  useAutoSubmitForm(handleSubmit(applyFilters), watch, [
    'generalFilter.fullName',
    'generalFilter.entityName',
  ]);

  const inputGeneralProps = {
    control,
    variant: 'outlined',
    size: 'small',
  } as const;

  const handleReset = () => {
    reset();
  };

  return (
    <GridTableRow
      variant="filter"
      component="form"
      onSubmit={(event) => event.preventDefault()}
    >
      <LbInput
        {...inputGeneralProps}
        name="generalFilter.fullName"
        placeholder="Full name"
      />
      {isSuperAdmin && (
        <LbInput
          {...inputGeneralProps}
          name="generalFilter.entityName"
          placeholder="Entity"
        />
      )}
      <div />
      <div />
      <Button
        variant="outlined"
        size="small"
        type="reset"
        fullWidth
        onClick={handleReset}
      >
        Clear All
      </Button>
    </GridTableRow>
  );
});

export { FilterRow };
